import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {  getVendor, resetVendorSession } from '../../../../service/AuthService';

const VHomePage = () => {
    const user = getVendor();
    const name = user !== "undefined" && user ? user.name : "";
    
    let navigate = useNavigate();

    const handleSignOut = () => {
      resetVendorSession();
      navigate("/vendor-signin");
    };
    useEffect(() => {
      return () => {
        
      };
    }, []);

  return (
       <div className="page-container">
      <div className="homepage-container">
        <div className="inner">
          <p>
            <h1>Welcome {name}</h1>
          </p>
        </div>
        <button onClick={handleSignOut}>Sign Out</button>
      </div>
    </div>
  );
}

export default VHomePage